import { useCallback } from 'react'
import { SwitchOrgOptions, useTokenProvider } from './TokenProvider'

/**
 * Hook to switch the current user's organisation.
 *
 * This uses TokenProvider which handles:
 * - Storing target org in localStorage (for cross-tab sync)
 * - Updating the session
 * - Hard refreshing the page to clear all caches and state
 *
 * Note: The returned function triggers a page refresh on success,
 * so the promise will only reject if an error occurs before the refresh.
 */
export const useSwitchOrganisation = () => {
  const { switchOrg } = useTokenProvider()

  return useCallback(
    async (organisationId: string, options?: SwitchOrgOptions) => {
      await switchOrg(organisationId, options)
    },
    [switchOrg]
  )
}
